import React, {
  useCallback,
} from 'react';
import format from 'string-template';
import PropTypes from 'prop-types';

import useToast from '../../../../../../hooks/useToast';
import { MAX_FILE_UPLOAD_SIZE, MAX_FILE_UPLOAD_SIZE_MB } from '../../../../../../../utils/files';
import InputLabel from '../../../../../../../components/v2/InputLabel';
import AttachmentsContainer from '../../../../../../components/AttachmentsContainer';

import { InputContainer } from './styles';
import texts from './texts.json';

const WeeklyMessageAttachmentContainer = ({
  fileAttachments,
  setFileAttachments,
  isUploading,
}) => {
  const { showToast } = useToast();

  const onFilesSelected = useCallback((event) => {
    const { files } = event.target;
    if (files.length) {
      const filesArray = [...files];
      const validFiles = filesArray.every((file) => file.size < MAX_FILE_UPLOAD_SIZE);
      if (validFiles) {
        const formattedFiles = filesArray.map((file) => {
          const lastDotIndex = file.name.lastIndexOf('.');
          return {
            dataUrl: URL.createObjectURL(file),
            format: file.name.slice(lastDotIndex + 1),
            fileName: file.name.slice(0, lastDotIndex),
            fileType: file.type,
            name: file.name,
            isUploaded: false,
          };
        });
        setFileAttachments((prev) => [...prev, ...formattedFiles]);
      } else {
        showToast(format(texts.fileSizeError, {
          maxFileSize: MAX_FILE_UPLOAD_SIZE_MB,
        }), { error: true });
      }
    }
  }, [
    showToast,
    setFileAttachments,
  ]);

  const removeFileByIndex = useCallback((index) => {
    const resultAttachments = [...fileAttachments];
    resultAttachments.splice(index, 1);
    setFileAttachments(resultAttachments);
  }, [
    fileAttachments,
    setFileAttachments,
  ]);

  return (
    <InputContainer>
      <InputLabel>{texts.attachments}</InputLabel>
      <AttachmentsContainer
        fileAttachments={fileAttachments}
        onFileRemoved={removeFileByIndex}
        onFilesSelected={onFilesSelected}
        isUploading={isUploading}
      />
    </InputContainer>
  );
};

WeeklyMessageAttachmentContainer.propTypes = {
  fileAttachments: PropTypes.arrayOf(PropTypes.object).isRequired,
  setFileAttachments: PropTypes.func.isRequired,
  isUploading: PropTypes.bool.isRequired,
};

export default WeeklyMessageAttachmentContainer;
